package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable

@Composable
actual fun ShowOverLockscreen(active: Boolean) {
    // El navegador no puede pintar sobre el bloqueo del sistema.
}
